import { useLocation, useNavigate } from 'react-router-dom';

function MergeResultPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { success, message } = location.state || { success: false, message: 'No result data' };

    const handleContinue = () => {
        navigate('/companies');
    };

    return (
    <div className="m-2 p-4">
        <div className='border border-solid border-color-tableGray rounded-md'>
            <div className="border-b border-solid border-titanium-white mb-5 bg-gotham-gray rounded-t-md">
                <h2 className="text-white font-semibold py-3 ml-7">Merge Companies</h2>
            </div>

            <h2 className={`mx-8 text-2xl font-semibold mb-1 ${success ? 'text-green-600' : 'text-red-600'}`}>
            {success ? 'Merge Successful' : 'Merge Failed'}
            </h2>
            
            <p className="mx-8 mb-6 font-semibold">{message}</p>

            <div className="my-4 mx-8 flex space-x-4">
                <button
                onClick={handleContinue}
                className="w-36 h-9 text-center text-white bg-gotham-gray border border-solid border-gotham-gray rounded-md focus:outline-none focus:border-blue-400 hover:bg-blue-400 hover:border-blue-500 disabled:opacity-50"
                >
                Continue
                </button>
            </div>
        </div>
    </div>
    );
}

export default MergeResultPage;
